import React, { Component } from "react"
import "./InTheNews.scss"
import PropTypes from "prop-types"
import AppContext from "../../shared/AppContext"

class NewsCard extends Component {
  constructor(props) {
    super(props)
    this.newsCardContent = React.createRef()
    this.newsCard = React.createRef()
  }

  openContent = () => {
    this.newsCardContent.current.classList.add("open")
    this.newsCard.current.classList.add("selected")
  }

  closeContent = () => {
    this.newsCardContent.current.classList.remove("open")
    this.newsCard.current.classList.remove("selected")
  }

  render() {
    const { imageUrl, text, borderColor, bgColor, textColor, url } = this.props
    return (
      <AppContext.Consumer>
        {({ trackEvent }) => {
          return (
            <div className="news-card" ref={this.newsCard}>
              <a
                href={url}
                target="_blank"
                onClick={() => trackEvent("Clicked News Card", { link: url })}
              >
                <img
                  src={imageUrl}
                  className="news-card__image"
                  onMouseEnter={this.openContent}
                  onMouseLeave={this.closeContent}
                />
              </a>
              <div
                className="news-card__content"
                style={{ borderColor: borderColor, backgroundColor: bgColor }}
                ref={this.newsCardContent}
              >
                <p
                  className="news-card__text"
                  style={{ color: textColor }}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </div>
            </div>
          )
        }}
      </AppContext.Consumer>
    )
  }
}

NewsCard.propTypes = {
  imageUrl: PropTypes.string,
  text: PropTypes.string,
  bgColor: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  url: PropTypes.string,
}

export default NewsCard
